import styled from 'styled-components';

import { ICD10_CHIP_HEIGHT } from '../medicineSelector.constants';

const StyledPharmindexLogo = styled.svg`
   flex: 0 0 auto;
   min-height: ${ICD10_CHIP_HEIGHT};
`;

StyledPharmindexLogo.displayName = 'StyledPharmindexLogo';

export { StyledPharmindexLogo };
